const iceBoxProcess = () => import('Views/iceBoxProcess/iceBox-process');

export default[
  { path: '/iceBox-process', component: iceBoxProcess },
];



// WEBPACK FOOTER //
// ./src/router/iceBoxProcess.js